import React from 'react';
import t from "../../../helpers/t";
import {dateFormat} from "../../../../utils/FormatHelper";
import moment from "moment";
import { DriveReport } from "./ReportsView";

type Props = {
    report: DriveReport,
    deleteReport: any,
    getReport: any,
    language: string,
    index: number|undefined,
    deleteReportPending: any,
    getReportPending: any
}
const ReportItem: (props: Props) => React.JSX.Element = (props: Props): React.JSX.Element => {
    const { report, deleteReport, getReport, language, index, deleteReportPending, getReportPending } = props;
    const getDate: (report: DriveReport) => (string) = (report: DriveReport):string => {
       const begin: string = moment(report.begin).format(dateFormat(language,false,false));
       const end: string = moment(report.end).format(dateFormat(language,false,false));
       if(begin === end){
           return begin;
       } 
       return begin + ' - ' + end;
    }
    return (
        <>
            <div className={"inb-c-item inb-c-item--report row "}  key={"div_row_"+report.id+"_standard"}>
                <div className="large-2 medium-2 small-4 column  padding-1" id="report-id" key={"div_report_id_"+report.id}>
                    <span title="date">
                        {getDate(report)}
                    </span>
                </div>
                <div className="large-2 medium-2 small-4 column  padding-1" id="report-name" key={"div_report_name_"+report.id}>
                    <span title="date">
                        {t("kilometers driven per resource")}
                    </span>
                </div>
                <div className="large-2 medium-2 small-4 column  padding-1" id="report-created" key={"div_report_created_"+report.id}>
                    <span title="date">
                        {moment(report.created).format(dateFormat(language,false,false))}
                    </span>
                </div>
                <div className="show-for-large column large-6 medium-6 small-12">
                    <div className="large-12 medium-offset-0 medium-8 item-button-group column " style={{justifyContent: "right"}}>

                        <div className="">
                                { deleteReportPending !== index && getReportPending !== index ? <>
                                    <div style={{paddingLeft: "10px",float: "right"}}>
                                        <a
                                            href="#"
                                            className="inb-reservation__pdf2"
                                            title={t('delete')}
                                        >
                                            <button type="button" className="inb-round-btn hollow round float-right"
                                                    onClick={() => deleteReport(report)}>
                                                <div className="inb-fi-remove"></div>
                                            </button>
                                        </a>
                                    </div>
                                    <div style={{float: "right"}}>
                                    <a
                                        href="#"
                                        className="inb-reservation__pdf2"
                                        title={t('view')}>
                                        <button type="button" className="inb-round-btn hollow round float-right"
                                                onClick={() => getReport(report)}>
                                            <div className="fi fi-page"></div>
                                        </button>
                                    </a>
                                    </div>

                                        </>: <>
                                    <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                </>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ReportItem;